<div class="db-disconnect-website-make-primary-dialog" >
    <div class="db-disconnect-website-make-primary-dialog__header mb10" [innerHTML]="'text_confirmMakePrimary.header' | dbText"></div>
    <div class="db-disconnect-website-make-primary-dialog__message">
        <p [innerHTML]="message" class="mb20"></p>
        <div class="ds-notification-gray mb30">
            <div>
                <i class="db-icon db-icon-ds-info-bg"></i>
                <p>
                    You have a connected website with the same domain name. Making this domain primary will<br/>automatically
                    remove it from {{ companyName }} dashboard.
                </p>
            </div>
        </div>
        <span class="ds-input-label" [innerHTML]="passwordMessage"></span>
        <input class="ds-input-black" type="password" [formControl]="removeWebsiteForm" [ngClass]="{'db-button_disabled': loading}" />
    </div>
    <div class="db-disconnect-website-make-primary-dialog__buttons mt30">
        <button class="ds-btn" [ngClass]="{'db-button_disabled': loading}" (click)="activeModal.close()"><span [innerHTML]="'text_cancel' | dbText"></span></button>
        <button class="ds-btn-black" [ngClass]="{'ds-btn-disabled': loading || removeWebsiteForm.invalid}" (click)="confirm()">
            <span *ngIf="!loading" [innerHTML]="'text_confirmMakePrimary.button' | dbText"></span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </button>
    </div>
</div>
